import { useEffect, useState, useContext, useRef } from "react";
import { useParams } from "react-router";

import Loader from "../loader";

import { LayoutContext } from "../layout/";
import { getEndpoint } from "../helper";

export default function BrandFileFullScreen({ }) {
    const [data, setData] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    const { brandId, brandFileId } = useParams();

    const slickRef = useRef(null);

    const { setPageTitle } = useContext(LayoutContext);

    useEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;

        const fetchData = async () => {
            try {
                setLoading(true);
                const response = await fetch(getEndpoint(`/api/android/brand/GetMedia?brandId=${brandId}`), { signal });
                const json = await response.json();
                setData(json.data);

                setPageTitle(json.data[0].brandTitle);

            } catch (err) {
                if (err.name !== "AbortError") setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchData();

        return () => controller.abort();
    }, []);

    useEffect(() => {
        if (!data || data.length === 0) return;

        let initialSlide = 0;

        for (let i = 0; i < data.length; i++) {
            if (data[i].id == brandFileId) {
                initialSlide = i;
                break;
            }
        }

        $(slickRef.current).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            rtl: true,
            initialSlide,
            infinite: false
        });
    }, [data]);

    if (loading) return <Loader />;
    if (error) return <p>Error: {error}</p>;

    return (
        <div className='bc-w h-100 d-f fd-c brand-info-fs'>
            <div dir='rtl' className='h-100'>
                <div className='js__slick' ref={slickRef}>
                    {data.map((x, i) => (
                        <div className='d-b' key={i}>
                            {
                                x.fileName.indexOf('.mp4') > 0
                                    ? <video src={getEndpoint(`/uploads/shop/brand-file/${x.fileName}`)} controls></video>
                                    : <img src={getEndpoint(`/uploads/shop/brand-file/${x.fileName}`)} />
                            }
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}